const exchangesList = [
  {
    exchId: 0,
    name: 'CoinTrackr',
  },
  // {
  //   exchId: 1,
  //   name: 'Binance',
  // },
  // {
  //   exchId: 2,
  //   name: 'CoinBase',
  // },
];

export default {
  title: 'CoinTrackr | Live Crypto Price Tracker, Portfolio & Review',
  version: '0.19',
  email: 'info@cointrackr.com',
  donateList: [
    {
      currency: 'BTC',
      value: '18UtrCNAaKXrdUGiM8rtfcLU2YWsgXetxw',
      link: 'https://blockchain.info/address/18UtrCNAaKXrdUGiM8rtfcLU2YWsgXetxw',
      active: false
    },
    {
      currency: 'ETH',
      value: '0xC1c11321526D00912E5c7D159897214d7Fc69a91',
      link: 'https://etherscan.io/address/0xC1c11321526D00912E5c7D159897214d7Fc69a91',
      active: true
    },
    {
      currency: 'LTC',
      value: 'LZaaBXbr2Vr7wbwFQKTHVHdRHt3PfKjX5w',
      link: 'https://blockchain.info/address/LZaaBXbr2Vr7wbwFQKTHVHdRHt3PfKjX5w',
      active: false
    },
  ],
  languages: [
    { language: "en", title: "English", abr: "EN" },
    { language: "fr", title: "Francais", abr: "FR" },
    { language: "es", title: "Español", abr: "ES" },
    { language: "zh-Hans", title: "中文（简体）", abr: "简体" },
    { language: "zh-Hant", title: "中文（繁體）", abr: "繁體" },
    { language: "ja", title: "日本語", abr: "日本語" },
  ],
  socials: [
    { name: "Facebook", link: "https://www.facebook.com/CoinTrackr-101803595567498", iconClass: "fa-facebook", showFooter: true, orderFooter: 0, showContact: true, orderContact: 1 },
    { name: "Twitter", link: "https://twitter.com/cointrackr", iconClass: "fa-twitter", showFooter: true, orderFooter: 1, showContact: true, orderContact: 0 },
    { name: "Linkedin", link: "https://www.linkedin.com/company/cointrackr/", iconClass: "fa-linkedin", showFooter: true, orderFooter: 3, showContact: true, orderContact: 2 },
    { name: "Instagram", link: "https://www.instagram.com/cointrackr/", iconClass: "fa-instagram", showFooter: true, orderFooter: 2, showContact: true, orderContact: 3 },
  ],
  currencies: [
    {
      label: 'U.S. Dollars',
      symbol: 'USD',
    },
    {
      label: 'Euros',
      symbol: 'EUR',
    },
    {
      label: 'Bitcoin',
      symbol: 'BTC',
    },
    {
      label: 'Ethereum',
      symbol: 'ETH',
    },
    {
      label: 'Australian Dollars',
      symbol: 'AUD',
    },
    {
      label: 'Brazilian Real',
      symbol: 'BRL',
    },
    {
      label: 'British Pounds',
      symbol: 'GBP',
    },
    {
      label: 'Canadian Dollars',
      symbol: 'CAD',
    },
    {
      label: 'Chilean Peso',
      symbol: 'CLP',
    },
    {
      label: 'Chinese Yuan',
      symbol: 'CNY',
    },
    {
      label: 'Czech Koruna',
      symbol: 'CZK',
    },
    {
      label: 'Danish Krone',
      symbol: 'DKK',
    },
    {
      label: 'Hong Kong Dollar',
      symbol: 'HKD',
    },
    {
      label: 'Hungarian Foriant',
      symbol: 'HUF',
    },
    {
      label: 'Indonesian Rupiah',
      symbol: 'IDR',
    },
    {
      label: 'Israeli New Sheqel',
      symbol: 'ILS',
    },
    {
      label: 'Indian Rupee',
      symbol: 'INR',
    },
    {
      label: 'Japanese Yen',
      symbol: 'JPY',
    },
    {
      label: 'Malaysian Ringgit',
      symbol: 'MYR',
    },
    {
      label: 'Mexican Peso',
      symbol: 'MXN',
    },
    {
      label: 'Norwegian Krone',
      symbol: 'NOK',
    },
    {
      label: 'New Taiwan Dollar',
      symbol: 'TWD',
    },
    {
      label: 'New Zealand Dollar',
      symbol: 'NZD',
    },
    {
      label: 'Philippine Peso',
      symbol: 'PHP',
    },
    {
      label: 'Pakistan Rupee',
      symbol: 'PKR',
    },
    {
      label: 'Polish Zloty',
      symbol: 'PLN',
    },
    {
      label: 'Russian Ruble',
      symbol: 'RUB',
    },
    {
      label: 'Singapore Dollar',
      symbol: 'SGD',
    },
    {
      label: 'South African Rand',
      symbol: 'ZAR',
    },
    {
      label: 'South Korean Won',
      symbol: 'KRW',
    },
    {
      label: 'Swedish Krona',
      symbol: 'SEK',
    },
    {
      label: 'Swiss Francs',
      symbol: 'CHF',
    },
    {
      label: 'Thai Baht',
      symbol: 'THB',
    },
    {
      label: 'Turkish New Lira',
      symbol: 'TRY',
    },
    {
      label: 'Bulgarian Lev',
      symbol: 'BGN',
    },
    {
      label: 'Romanian Ley',
      symbol: 'RON',
    },
    {
      label: 'Icelandic Krona',
      symbol: 'ISK',
    },
    {
      label: 'Croatian Kuna',
      symbol: 'HRK',
    },
  ],
  sortByColumns: [
    { name: "name", iconType: "alpha", sortType: "text" },
    { name: "exchId", iconType: "alpha", sortType: "number" },
    { name: "price", iconType: "amount", sortType: "number" },
    { name: "holdings", iconType: "amount", sortType: "number" },
    { name: "value", iconType: "amount", sortType: "number" },
    { name: "percChangeHour", iconType: "amount", sortType: "number" },
    { name: "percChangeDay", iconType: "amount", sortType: "number" },
    { name: "percChangeWeek", iconType: "amount", sortType: "number" },
  ],
  sortByColumns_profitloss: [
    { name: "name", iconType: "alpha", sortType: "text" },
    { name: "price", iconType: "amount", sortType: "number" },
    { name: "sum_total", iconType: "amount", sortType: "number" },
    { name: "assetPrice_avg", iconType: "amount", sortType: "number" },
    { name: "percChangeHour", iconType: "amount", sortType: "number" },
    { name: "percChangeDay", iconType: "amount", sortType: "number" },
    { name: "percChangeWeek", iconType: "amount", sortType: "number" },
    { name: "pl_total", iconType: "amount", sortType: "number" },
  ],
  stateKeyInLS: 'state',
  defaultSortBy: 'name',
  defaultLang: 'en',
  defaultCurrency: 'USD',
  defaultAssets: [
    {
      currency: 'BTC',
      holdings: 1.1,
      currencyId: 'bitcoin'
    },
    {
      currency: 'ETH',
      holdings: 8,
      currencyId: 'ethereum'
    },
    {
      currency: 'LTC',
      holdings: 20,
      currencyId: 'litecoin'
    },
    {
      currency: 'XRP',
      holdings: 2500,
      currencyId: 'xrp'
    },
    {
      currency: 'XMR',
      holdings: 15,
      currencyId: 'monero'
    },
    {
      currency: 'LSK',
      holdings: 250,
      currencyId: 'lisk'
    },
  ],
  chartColors: [
    '#072A49',
    '#108A9F',
    '#B7C721',
    '#431833',
    '#F0CC2C',
    '#FC9314',
    '#DC4709',
    '#537F78',
    '#B8D7CA',
    '#FAF0D3',
    '#333333',
    '#BB6A46',
    '#543140',
    '#A0DEB5',
    '#D6C22D',
    '#5DA5DA',
    '#F15854',
    '#B2912F',
    '#B276B2',
    '#aaaaaa',
    '#072A49',
    '#108A9F',
    '#B7C721',
    '#431833',
    '#F0CC2C',
    '#FC9314',
    '#DC4709',
    '#537F78',
    '#B8D7CA',
    '#FAF0D3',
    '#333333',
    '#BB6A46',
    '#543140',
    '#A0DEB5',
    '#D6C22D',
    '#5DA5DA',
    '#F15854',
    '#B2912F',
    '#B276B2',
    '#aaaaaa',
    '#072A49',
    '#108A9F',
    '#B7C721',
    '#431833',
    '#F0CC2C',
    '#FC9314',
    '#DC4709',
    '#537F78',
    '#B8D7CA',
    '#FAF0D3',
    '#333333',
    '#BB6A46',
    '#543140',
    '#A0DEB5',
    '#D6C22D',
    '#5DA5DA',
    '#F15854',
    '#B2912F',
    '#B276B2',
    '#aaaaaa',
  ],
  coinmarketcapIntervalTimeout: 1000 * 60 * 10,
  coinmarketcapIntervalTimeout_afterError: 1000 * 15,

  notesMaxLength: 500,

  exchangesList,
  exchIdToObj: (exchId: number) => {
    return exchangesList.find((v) => exchId === v.exchId);
  },

  // local
  // coinmarketcapListUrl: 'http://localhost:3000/list?checkError=true',
  // currencyListUrl: 'http://localhost:3000/list?rates=1',

  // dev
  // firebaseConfig: {
  //   apiKey: "AIzaSyDXWSlAWtN-bckQ7HnZvKe24KN188IHB4w",
  //   authDomain: "cointrackr2.firebaseapp.com",
  //   databaseURL: "https://cointrackr2-default-rtdb.firebaseio.com",
  //   projectId: "cointrackr2",
  //   storageBucket: "cointrackr2.appspot.com",
  //   messagingSenderId: "1080205996617",
  //   appId: "1:1080205996617:web:3148577be7fac532620598",
  //   measurementId: "G-M5RZZ94ZEQ"
  // },
  // exchangeApiBaseURL: 'https://dev.cointrackr.com/exch', // 'http://139.59.211.35:8000',
  // coinmarketcapListUrl: '/list?checkError=true',
  // currencyListUrl: '/list?rates=1',

  // prod
  firebaseConfig: {
    apiKey: 'AIzaSyC-eplp02RPLtftqgUyGQZjTOBA8fyoC3Q',
    authDomain: 'cointrackr-8c3da.firebaseapp.com',
    databaseURL: 'https://cointrackr-8c3da.firebaseio.com',
    projectId: 'cointrackr-8c3da',
    storageBucket: 'cointrackr-8c3da.appspot.com',
    messagingSenderId: '582595314206',
    appId: '1:582595314206:web:58d08295c07de14f3e240f',
  },
  exchangeApiBaseURL: 'https://cointrackr.com/exch', // 'http://137.184.53.109:8000'
  coinmarketcapListUrl: '/list?checkError=true',
  currencyListUrl: '/list?rates=1',
};
